import React from 'react';

const Auth = React.lazy(() => import('../../modules/auth/Auth'));

export const thirdPartyAuthRoutesConfig = [
  {
    path: '/auth',
    element: <Auth />,
  },
];
